export enum DoiSearchWordMode
{
	All, Any, Phrase
}
